module.exports = __webpack_public_path__ + "static/img/cd.e0101fc8.svg";